import departmentsService from '@/services/departments.service'

export default {
  namespaced: true,
  state: {
    departments: [],
    loading: false,
    error: null
  },
  mutations: {
    SET_DEPARTMENTS(state, departments) {
      state.departments = departments
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    },
    ADD_DEPARTMENT(state, department) {
      state.departments.push(department)
    },
    UPDATE_DEPARTMENT(state, updatedDepartment) {
      const index = state.departments.findIndex(d => d.id === updatedDepartment.id)
      if (index !== -1) {
        state.departments.splice(index, 1, updatedDepartment)
      }
    },
    REMOVE_DEPARTMENT(state, id) {
      state.departments = state.departments.filter(d => d.id !== id)
    }
  },
  actions: {
    async fetchDepartments({ commit }) {
      try {
        commit('SET_LOADING', true)
        commit('SET_ERROR', null)
        const response = await departmentsService.getAll()
        // Handle paginated response - data is nested in response.data.data
        const departments = response.data?.data || response.data || []
        commit('SET_DEPARTMENTS', departments)
      } catch (error) {
        commit('SET_ERROR', error.response?.data?.message || error.message)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async createDepartment({ commit }, departmentData) {
      try {
        commit('SET_LOADING', true)
        commit('SET_ERROR', null)
        const response = await departmentsService.create(departmentData)
        if (response.success) {
          commit('ADD_DEPARTMENT', response.data)
          return { success: true, data: response.data }
        }
        throw new Error(response.message)
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message
        commit('SET_ERROR', errorMessage)
        return { success: false, error: errorMessage }
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async updateDepartment({ commit }, { id, departmentData }) {
      try {
        commit('SET_LOADING', true)
        commit('SET_ERROR', null)
        const response = await departmentsService.update(id, departmentData)
        if (response.success) {
          commit('UPDATE_DEPARTMENT', response.data)
          return { success: true, data: response.data }
        }
        throw new Error(response.message)
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message
        commit('SET_ERROR', errorMessage)
        return { success: false, error: errorMessage }
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async deleteDepartment({ commit }, id) {
      try {
        commit('SET_LOADING', true)
        commit('SET_ERROR', null)
        const response = await departmentsService.delete(id)
        if (response.success) {
          commit('REMOVE_DEPARTMENT', id)
          return { success: true }
        }
        throw new Error(response.message)
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message
        commit('SET_ERROR', errorMessage)
        return { success: false, error: errorMessage }
      } finally {
        commit('SET_LOADING', false)
      }
    }
  },
  getters: {
    allDepartments: state => state.departments,
    activeDepartments: state => state.departments.filter(d => d.active),
    departmentsByCompany: state => companyId => state.departments.filter(d => d.company_id === companyId),
    isLoading: state => state.loading
  }
}

